import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import Slider, { Range } from 'rc-slider';

import SidebarElementSpacing from './SidebarElementSpacing.js';

import PaddingPicker from './PaddingPicker.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import FontPicker from './FontPicker.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class Header extends React.Component {
	constructor(props) {	
		super(props);
		
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
		this.onTextChange = this.onTextChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onChange = this.onChange.bind(this);



	}

	onChange(v) {
    	this.props.setComponentState(this.el().id,{paddingTop:v+'px'});
    }

	onTextChange(e) {
		this.props.setComponentState(this.el().id,{[e.target.id]:e.target.value});
	}

	handleChange(id,s) {
		let changes = {};
    	changes[id] = s; 
		this.props.setComponentState(this.el().id,changes);
	}


    el() {
    	return this.props.builder.components[this.props.id];
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }


    render() {
    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>
	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Header" />
	    				<div className="panel-group panel-group-continuous" id="text-settings" aria-multiselectable="true" role="tablist">

            				<SidebarSettingAccordion selectedSetting={false} optionKey="right" parent="text-settings" title="Text right">
            					<SidebarElementSetting text="Text">
									<input type="text" value={this.el().right_text} id="right_text" onChange={this.onTextChange} className="form-control" />
								</SidebarElementSetting>

            					<SidebarElementSetting text="Font style">
									<FontPicker 
										fontId='right_font' 
										sizeId='right_size'
										colorId='right_color'
										font={this.el().right_font} 
										size={this.el().right_size}
										color={this.el().right_color} 
										handleChange={this.handleChange} 
									/>
								</SidebarElementSetting>


            				</SidebarSettingAccordion>

            				<SidebarSettingAccordion selectedSetting={false} optionKey="left" parent="text-settings" title="Text left">
            					<SidebarElementSetting text="Text">
									<input type="text" value={this.el().left_text} id="left_text" onChange={this.onTextChange} className="form-control" />
								</SidebarElementSetting>

            					<SidebarElementSetting text="Font style">
									<FontPicker 
										fontId='left_font' 
										sizeId='left_size'
										colorId='left_color'
										font={this.el().left_font} 
										size={this.el().left_size}
										color={this.el().left_color} 
										handleChange={this.handleChange} 
									/>
								</SidebarElementSetting>
            				</SidebarSettingAccordion>

            				<SidebarSettingAccordion selectedSetting={false} optionKey="padding" parent="text-settings" title="Spacing">
            					<SidebarElementSetting text="Spacing top">
				    			<Slider value={parseInt(this.el().paddingTop.replace('px',''))}
										onChange={this.onChange} 
										min={0}
										max={400}
								      />
							</SidebarElementSetting>
            				</SidebarSettingAccordion>
            			</div>
	    		</div>


    		);
    	}else{
    		return (
	      		<table style={{width:'100%',marginTop:this.el().paddingTop}}>
	      			<tbody>
	      			<tr>
	      				<td style={{textAlign:'left',width:'50%'}}>
	      					<span style={{fontSize:this.el().left_size,fontFamily:this.el().left_font,color:this.el().left_color}}>{this.el().left_text}</span>
	      				</td>
	      				<td style={{textAlign:'right',width:'50%'}}>
	      					<span><a href="#" style={{fontSize:this.el().right_size,fontFamily:this.el().right_font,color:this.el().right_color}}>{this.el().right_text}</a></span>
	      				</td>
	      			</tr>
	      			</tbody>
	      		</table>
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

Header = connect(mapStateToProps,mapDispatchToProps)(Header);

export default Header;





// WEBPACK FOOTER //
// ./components/builder/Header.js